import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "#5F6A7D",
  viewBox: "-1 -1 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M3.529 3.529c.26-.26.682-.26.943 0l8 8a.667.667 0 0 1-.943.943l-8-8a.667.667 0 0 1 0-.943",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12.471 3.529a.667.667 0 0 0-.943 0l-8 8a.667.667 0 1 0 .943.943l8-8a.667.667 0 0 0 0-.943",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }